// extracted by mini-css-extract-plugin
export default {"wrapper":"Token_wrapper__QGZmW","banner":"Token_banner__3Velt","tokenWrapper":"Token_tokenWrapper__fex4Z","image":"Token_image__5GRvX","medium":"Token_medium__JhXgL"};